import axAPI from "../../../../api/axios-instance";

interface AddSlugPlayerParams {
  fnlId: string | number;
  slug: string;
}

export const addSlugPlayer = async ({
  fnlId,
  slug,
}: AddSlugPlayerParams): Promise<void> => {
  try {
    const response = await axAPI.post("/cms/fnlId/players/slug", {
      fnlId,
      slug,
    });

    if (response.status === 200) {
      return;
    } else {
      throw new Error(`Unexpected response: ${response.status}`);
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 409) {
        throw new Error("Слаг занят другим игроком");
      }
      throw new Error(
        `Ошибка при сохранении слага игрока: ${error.response.status} - ${error.response.data}`
      );
    }
    throw new Error("Ошибка сети или неизвестная ошибка");
  }
};
